<template>
<div class="modal fade" id="modalBulkCompanyTags" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Tags em massa — Empresas</h4>
        <p class="subtitle-modal">
          Adicione ou remova uma tag em <strong>{{ companyIds.length }}</strong>
          empresa(s) selecionada(s). Limite de <strong>200</strong> empresas por vez.
        </p>
      </div>

      <div class="modal-body">
        <div class="over-limit" v-if="overLimit">
          Você selecionou {{ companyIds.length }} empresas. O limite é 200 por operação —
          reduza a seleção antes de aplicar.
        </div>

        <div class="form-group">
          <label>Ação</label>
          <div class="action-row">
            <label class="action-opt">
              <input type="radio" value="add" v-model="action"/>
              Adicionar tag
            </label>
            <label class="action-opt">
              <input type="radio" value="remove" v-model="action"/>
              Remover tag
            </label>
          </div>
        </div>

        <div class="form-group">
          <label>Tag</label>
          <select v-model="tagId">
            <option value="">Selecione uma tag</option>
            <option v-for="t in tags" :key="t.id" :value="t.id">{{ t.name }}</option>
          </select>
        </div>

        <div v-if="error" class="error-msg">{{ error }}</div>
      </div>

      <div class="modal-footer">
        <button class="btn-cancel" v-on:click="closeModal()">Cancelar</button>
        <button class="btn-apply" v-on:click="submit()"
                :disabled="loading || !canSubmit">
          <span v-if="!loading">{{ action === 'remove' ? 'Remover' : 'Adicionar' }}</span>
          <span v-else>Aplicando...</span>
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { COMPANY_TAGS_BULK } from "../../../urlConfig";
import { REQUEST_SERVICE } from "../../../requestConfig";
import swal from "sweetalert";

export default {
  name: "modalBulkCompanyTags",
  props: {
    companyIds: { type: Array, default: () => [] },
    tags: { type: Array, default: () => [] }
  },
  data() {
    return {
      action: "add",
      tagId: "",
      loading: false,
      error: ""
    };
  },
  computed: {
    overLimit() {
      return this.companyIds.length > 200;
    },
    canSubmit() {
      return !!this.tagId && this.companyIds.length > 0 && !this.overLimit;
    }
  },
  mounted() {
    // Garante estado limpo a cada abertura (o modal é uma instância persistente
    // controlada por jQuery/Bootstrap; sem isso, ação/erro/tag anteriores vazam).
    var self = this;
    $("#modalBulkCompanyTags").on("show.bs.modal", function () {
      self.resetState();
    });
  },
  methods: {
    resetState() {
      this.action = "add";
      this.tagId = "";
      this.error = "";
      this.loading = false;
    },
    closeModal() {
      $("#modalBulkCompanyTags").modal("toggle");
    },
    submit() {
      this.error = "";
      if (!this.canSubmit) return;
      this.loading = true;

      const remove = this.action === "remove";
      const payload = {
        tagId: this.tagId,
        companyIds: this.companyIds,
        remove: remove
      };

      REQUEST_SERVICE.post(COMPANY_TAGS_BULK, payload)
        .then((response) => {
          this.loading = false;
          const affected = (response && response.data && response.data.affected) || 0;
          const failed = (response && response.data && response.data.failed) || 0;
          const verb = remove ? "removida(s)" : "adicionada(s)";
          let msg = `Tag ${verb} em ${affected} empresa(s).`;
          if (failed > 0) msg += ` ${failed} falhou(aram).`;
          swal("Sucesso", msg, "success");
          this.tagId = "";
          $("#modalBulkCompanyTags").modal("toggle");
          this.$emit("done");
        })
        .catch((reason) => {
          this.loading = false;
          const data = reason && reason.response && reason.response.data;
          this.error = (typeof data === "string" && data) ? data : "Falha na operação. Verifique os dados.";
        });
    }
  }
};
</script>

<style lang="scss">
#modalBulkCompanyTags {
  .modal-header { padding: 15px 15px 0; border-bottom: none; }
  .title-modal {
    text-align: center; font-weight: bold; padding-top: 10px;
    letter-spacing: 1px; text-transform: uppercase;
  }
  .subtitle-modal {
    text-align: center; color: #777; font-size: 13px;
    padding: 0 30px; margin-top: 8px;
  }
  .modal-body { padding: 20px 40px; }

  .over-limit {
    background: #fcf3e6; border-left: 4px solid #f0ad4e; color: #7a5b1e;
    padding: 10px 14px; border-radius: 4px; font-size: 13px; margin-bottom: 16px;
  }

  .form-group { margin-bottom: 16px; }
  .form-group label { font-weight: 600; margin-bottom: 6px; display: block; }
  .form-group select {
    width: 100%; border: 1px solid #ccc; border-radius: 4px; padding: 8px 12px;
  }

  .action-row { display: flex; gap: 20px; }
  .action-opt {
    display: inline-flex; align-items: center; gap: 6px;
    font-weight: 500; margin: 0; cursor: pointer;
  }

  .error-msg { color: #e74a4e; margin-top: 12px; font-size: 13px; text-align: center; }

  .modal-footer {
    .btn-cancel {
      border-radius: 4px; background: #8b8787; color: #fff;
      padding: 7px 22px; border: none; font-weight: 600;
    }
    .btn-apply {
      border-radius: 4px; background: #3598dc; color: #fff;
      padding: 7px 22px; border: none; font-weight: 600; margin-left: 8px;
    }
    .btn-apply:disabled { opacity: 0.5; cursor: not-allowed; }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalBulkCompanyTags.vue